import { Component, OnInit } from '@angular/core';
import {
  ApplicationState,
  getCloudProductsPrice,
  getProducts,
} from '../../store/reducers';
import { OnDestroyHookDirective } from '../../shared/hooks';
import { Store } from '@ngrx/store';
import {
  Option,
  OptionStatus,
  Price,
  Product,
} from '@dch/products-business-logic';
import { GetCloudProductPrice } from '../store/actions/cloud.actions';
import { getPiiCloudServiceId } from '../../shared/pii/pii.utils';
import * as ProductsActions from '../../store/actions/products.actions';

@Component({
  selector: 'mprd-cloud-subscription',
  templateUrl: './cloud-subscription.component.html',
  styleUrls: ['./cloud-subscription.component.css'],
})
export class CloudSubscriptionComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  serviceId: string;
  fakeCloudOption: Option;
  cloudDescription: string;
  private dataLoaded: boolean;

  constructor(private store: Store<ApplicationState>) {
    super();
  }

  ngOnInit() {
    this.serviceId = getPiiCloudServiceId();
    this.addSubscription(
      this.store.select(getCloudProductsPrice).subscribe((price) => {
        if (
          price &&
          price.calculated_prices &&
          price.calculated_prices.length > 0
        ) {
          this.fakeCloudOption = this.buildFakeOption(
            price.calculated_prices[0],
          );
        }
      }),
    );
    this.addSubscription(
      this.store.select(getProducts).subscribe((products) => {
        if (products && products.length > 0 && !this.dataLoaded) {
          this.dataLoaded = true;
          const product = this.findProduct(products, this.serviceId);
          if (product) {
            this.cloudDescription = product.productDescription;
          }
          this.store.dispatch(
            new GetCloudProductPrice({
              mpcUuid: product.groupMpcUuid,
              packMpcUuid: product.packMpcUuid,
              chargeConfiguration: product.chargeConfiguration,
            }),
          );
        }
      }),
    );
    this.store.dispatch(new ProductsActions.GetProducts());
  }

  private buildFakeOption(price: any) {
    return {
      ibStatus: OptionStatus.ACTIVE,
      hideIncludedLabel: true,
      price: {
        calculatedPriceNoVat: price.calculated_price_no_vat,
        calculatedPriceVat: price.calculated_price_vat,
        priceNoVat: price.price_no_vat,
        priceVat: price.price_vat,
        chargeFrequency: price.charge_frequency,
      } as Price,
    } as Option;
  }

  private findProduct(products: Array<Product>, serviceId: string) {
    const filteredProducts =
      serviceId &&
      products.filter((product) => serviceId === product.accessNumber);
    if (filteredProducts && filteredProducts.length > 0) {
      return filteredProducts[0];
    }
    return undefined;
  }
}
